import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/client";
import { naturalSortKey } from "@/utils/naturalSort";

interface ProjectOption {
  id: string;
  short_name: string;
  name: string;
  is_active: boolean;
}

export function useProjects() {
  return useQuery({
    queryKey: ["projects-for-tasks"],
    queryFn: () =>
      apiClient
        .get<{ data: ProjectOption[] }>("/projects/", { params: { is_active: "true" } })
        .then((r) =>
          r.data.data.sort((a, b) => {
            const key = (p: ProjectOption) => `${naturalSortKey(p.short_name)}_${naturalSortKey(p.name)}`;
            return key(a).localeCompare(key(b), "pl");
          }),
        ),
    staleTime: 5 * 60 * 1000,
  });
}
